import { Connection } from "./Connection.model"

export class SqlConnection extends Connection {
    public serverName!: string
    public database!: string
    public userName!: string
    public password!: string
}